import React, {useRef,useState}  from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import {  AppBar,Typography, Toolbar, Stack,Button, Grid,IconButton,Box,Modal } from '@mui/material'
import logo from '../res/logo/logo-canv.png'
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Image from 'mui-image'


let buttonStyle = {
  
  fontSize: {xs:'14px', sm:'18px',md:'20px',lg:'24px'},
  color: '#444',
  // fontFamily: 'Dancing Script,cursive',
  '&:hover':{
    backgroundColor: 'transparent',
    // textDecoration: 'underline'
    borderBottom:`${4}px solid`,
    borderColor: 'secondary.dark'
    
  },
  rippleVisible: {
    opacity: 0,
    
  },
}

const headButton={
  fontSize:28,
  color:'#333',
  fontFamily:'Dancing Script,cursive',
  // fontWeight:700,
}

let menuButton={
  color:'primary.light',
  fontSize:{xs:28,sm:30}
}

const menuStyle = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0,0,0,.4)',
  
  justifyContent:'center',
  paddingTop:24,
  display: 'flex',
  marginBottom:12
 
};

const Header = ({home,gallery,services,contact,customer}) => {
  let [menuOpen,setMenuOpen]= useState()
  const theme = useTheme()
  const lg_down = useMediaQuery(theme.breakpoints.down('lg'));
  const lg_up = useMediaQuery(theme.breakpoints.up('lg'));
  const md_up = useMediaQuery(theme.breakpoints.up('md'));
  const sm_down = useMediaQuery(theme.breakpoints.down('sm'));
  
  let scrollTo = (ref)=> {
    if (!ref.current) return;
    ref.current.scrollIntoView({ behavior: "smooth" });
  }

  function useWidth() {
    const theme = useTheme();
    const keys = [...theme.breakpoints.keys].reverse();
    return (
      keys.reduce((output, key) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const matches = useMediaQuery(theme.breakpoints.up(key));
        return !output && matches ? key : output;
      }, null) || 'xs'
    );
  }

  const width = useWidth();
  let imgWidth;
  switch(width){
    case 'xs':
      imgWidth='40px'
      break;
    case 'sm':
      imgWidth='40px'
      break;
    case 'md':
      imgWidth='40px'
      break;
    case 'lg':
      imgWidth='52px'
      break;
    case 'xl':
      imgWidth='52px'
      break;

  }



  return (
    
    // #ebd0a7
   <AppBar position="sticky" sx={{background:
    // "linear-gradient(to bottom, #f3abbc,rgba(210,165,90,0.3),rgba(210,165,90,0.2))",
    "linear-gradient(to bottom,rgba(230,208,171,.9), 80%,rgba(235, 208, 167,0.1))",
    // 'rgba(230,208,171,.9)',
   boxShadow:0,borderRadius:0,width:'100vw',padding:{xs:0,md:1,lg:0}}}>
       <Toolbar sx={{display:'flex' ,pl:1,pr:0}}>

         <Grid container sx={{width:1,}} justifyContent='space-between'>

           <Grid container item xs={2} justifyContent='flex-start'>
              {/* <Typography variant="h5" fontSize={{xs:48,md:60}}>Logo</Typography> */}
              <Image fit='contain' src={logo} alt="D'Core Paperie logo" height={imgWidth} width={imgWidth}
               onClick={()=>{scrollTo(home)}}/>
           </Grid>

           <Grid container item alignItems='center' justifyContent='flex-end' xs={10}  sx={{marginLeft:{xs:0}, paddingRight:2}}>
              <Stack direction='row' gap={1} sx={{display:{xs:'none',md:'block'}}}>
                {/* <Button  disableRipple sx={buttonStyle} onClick={()=>{scrollTo(gallery)}}>Gallery</Button> */}
                <Button  disableRipple sx={buttonStyle} onClick={()=>{scrollTo(services)}}>Services</Button>
                <Button  disableRipple sx={buttonStyle} onClick={()=>{scrollTo(customer)}}>Reviews</Button>
                <Button disableRipple sx={buttonStyle} onClick={()=>{scrollTo(contact)}}>Contact</Button>
              </Stack>
              <IconButton sx={{display:{xs:menuOpen?'none':'block',md:'none'}}}onClick={()=>{setMenuOpen(!menuOpen)}}>
                <MenuIcon sx={menuButton}/>
            </IconButton>
            </Grid>
           
         </Grid>
       
            
            
        
       
       </Toolbar>
       <Modal
        open={menuOpen}
        onClose={()=>setMenuOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"

      >
        
        <Box flexDirection='column' backgroundColor= 'rgba(0,0,0,.4)'>
          <Box display='flex' justifyContent="flex-end" >
          <IconButton onClick={()=>{setMenuOpen(false)}} sx={{margin:0.2}}>
            <CloseIcon sx={{...menuButton,color:'white'}}/>
          </IconButton>
        </Box>
        <Box sx={menuStyle}>
          <Stack sx={{position: 'absolute',top:'10%'}}>
          <Button sx={{...headButton,color:'white'}} onClick={()=>{scrollTo(home);setMenuOpen(false)}}>Home</Button>
            <Button sx={{...headButton,color:'white'}} onClick={()=>{scrollTo(services);setMenuOpen(false)}}>About</Button>
            <Button sx={{...headButton,color:'white'}}  onClick={()=>{scrollTo(customer);setMenuOpen(false)}}>Shop</Button>
            <Button sx={{...headButton,color:'white'}} onClick={()=>{scrollTo(contact);setMenuOpen(false)}}>contact</Button>
          </Stack>
        </Box>
        </Box>
      </Modal>
       
   </AppBar>
  )
}

export default Header